import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ProductImage from './ProductImage';
import * as api from '../../moltin';


import { UPDATE_QUANTITY } from '../../ducks/product';
import {
  FETCH_CART_START,
  FETCH_CART_END,
  CART_UPDATED
} from '../../ducks/cart';


const mapStateToProps = state => {
  return state;
};

class SingleProduct extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: " ",
      buttonText: 'Add to Cart ',// default sort param
      quickCheck: false,
    }
    this.handleChange = this.handleChange.bind(this);
  
  }

  // componentDidMount(){
  //   this._disabledButton();
  // }

  handleChange(event) {
    this.setState({value: event.target.value});
   { this.state.value === '0' ? this.setState({buttonText: 'Select Color'}) : this.setState({buttonText: 'Add to Cart'})};

    
  }




  render() {
    var products = this.props.products.products;

    var ID = this.props.router.location.pathname.slice(9, 100);

    var productArray = this.props.products.products.data.filter(function(
      product
    ) {
      return product.id === ID;
    });

    var product = productArray[0];

    var updateQuantity = quantity => {
      this.props.dispatch(dispatch => {
        dispatch({ type: UPDATE_QUANTITY, payload: quantity });
      });
    };

    var addToCart = id => {
      this.props.dispatch(dispatch => {
        api
          .AddCart(id, this.props.product.quantity)

          .then(cart => {
            console.log(cart);
            dispatch({ type: CART_UPDATED, gotNew: false });
          })

          .then(() => {
            dispatch({ type: FETCH_CART_START, gotNew: false });

            api
              .GetCartItems()

              .then(cart => {
                dispatch({ type: FETCH_CART_END, payload: cart, gotNew: true });
              });
          })
          .catch(e => {
            console.log(e);
          });
      });
    };

    let addCustom = () => {
      this.props.dispatch(dispatch => {
        api
          .browPomade(pomade(this.state.value))

          .then(cart => {
            console.log(cart);
            dispatch({ type: CART_UPDATED, gotNew: false });
          })

          .then(() => {
            dispatch({ type: FETCH_CART_START, gotNew: false });

            api
              .GetCartItems()

              .then(cart => {
                dispatch({ type: FETCH_CART_END, payload: cart, gotNew: true });
              });
          })
          .catch(e => {
            console.log(e);
          });
      });
    };

    var background = product.background_colour;

    function isThereACurrencyPrice() {
      try {
        return (
          <p className="price">
            <span className="hide-content">Unit price </span>
            {'$' + product.meta.display_price.with_tax.amount / 100}
          </p>
        );
      } catch (e) {
        return <div className="price">Price not available</div>;
      }
    }
    
  //  let   handleBrow = (event) => {
  //     colorBrow = {name: event.target.value}
//   //   }
//  componentDidMount() {
//   product.name.includes("Brow") ?  
//  }


  let pomade = (selectedColor) => {
    return (

      {
        type: "custom_item",
        name: `${selectedColor}` ,
        sku: `${selectedColor}`,
        "image": {
          "mime_type": ".png",
          "file_name": "selected brow-color.png",
          "href": "https://firebasestorage.googleapis.com/v0/b/prettylashed-c38d7.appspot.com/o/selected%20brow-color.png?alt=media&token=66761081-2d63-491c-a237-8d11f429c560"
      },
    
        description: 'brow color selected',
        quantity: 1,
        price: {
          amount: 1000,
          currency: 'usd',
          
        }
      }

      
     );
    
  }

    return (

      
      <main role="main" id="container" className="main-container push">
        <section className="product">
          <div className="content">
            <div className="product-listing">
              <div className="product-image">
                <ProductImage
                  product={product}
                  products={products}
                  background={background}
                />
              </div>
              <div className="product-description">
                <h2>{product.name}</h2>
                <p className="manufacturer">
                  <span className="hide-content">Manufactured </span>By{' '}
                  <span className="word-mark">
                    I<span className="love">Love</span>Pretty and Lashed
                  </span>
                </p>
                {isThereACurrencyPrice()}
                <div className="description">
                  <p className="hide-content">Product details:</p>
                  <p>{product.description}</p>
                  <div> 
                   { product.name.includes("Brow") && product.name.includes("Pomade") ?
                   <label>
                   
                    <select onSelect={(e) => this.handlechange(e)}   style={this.state.buttonText === "Select Color" ? {backgroundColor: "red", color: "white"} : { color: "black"}} value={this.state.value} onChange={(e) => this.handleChange(e)}>
                     <option value="0">Select Color:</option>
                     <option value="0"></option>
                      <option value=".Auburn Brow Pomade">Auburn</option>
                      <option value=".Soft Brown Brow Pomade">Soft Brown</option>
                      <option value=".Dark Brown Brow Pomade">Dark Brown</option>
                      <option value=".Taupe Brow Pomade">Taupe</option>
                      <option value=".Blonde Brow Pomade">Blonde</option>
                      <option value=".Brown Brow Pomade">Brown</option>
                      <option value=".Black Brow Pomade">Black</option>
                      <option value=".Medium Brow brown Pomade">Medium Brown</option>
                    </select>
                   </label>
                    : " " }
                   </div> 
                </div>
                <form className="product" noValidate>
                  <div className="quantity-input">
                    <p className="hide-content">Product quantity.</p>
                    <p className="hide-content">
                      Change the quantity by using the buttons, or alter the
                      input directly.
                    </p>
                    <button
                      type="button"
                      className="decrement number-button"
                      disabled={this.state.value === "0" && product.name.includes("Brow") ? true : false}
                      onClick={() => {
                        updateQuantity(this.props.product.quantity - 1);
                        this.setState({buttonText: "Add to cart"});
                      }}>
                      <span className="hide-content">Decrement quantity</span>
                      <span aria-hidden="true">-</span>
                    </button>
                    <input
                      className="quantity"
                      name="number"
                      type="number"
                      min="1"
                      max="10"
                      value={
                        product.name.includes("brows") ?
                          this.state.value === '0' ? 0 : this.props.product.quantity :
                          this.props.product.quantity
                        }
                       
                      size="2"
                      onChange={event => {
                        updateQuantity(event.target.value);
                      }}
                    />
                    <button
                      type="button"
                      className="increment number-button"
                      disabled={this.state.value === "0" && product.name.includes("Brow") ? true : false}
                      onClick={() => {
                        updateQuantity(this.props.product.quantity + 1);
                        this.setState({buttonText: "Add to cart"});
                      }}>
                      <span className="hide-content">Increment quantity</span>
                      <span aria-hidden="true">+</span>
                    </button>
                  </div>

              {product.name.includes("Brow") && product.name.includes("Pomade") ?
              <button
                    type="submit"
                    className="submit"
                    style={this.state.buttonText === 'Select Color' ? {backgroundColor: "red"}  : null}
                    disabled={
                     this.state.value === "0" && this.state.buttonText === 'Select Color' ? true : false }
                    onClick={e => {
                      // { if ( this.state.value !== '0') {addToCart(product.id)}};
                      console.log(this.props.product.quantity);
                      console.log(this.state.value);
                      (this.state.value === "0" ? this.setState({buttonText: "Select Color"}) : null);
                      // eslint-disable-next-line
                      { product.name.includes("Brow") && this.state.value !== '0' ?
                      this.state.value !== "0" ? 
                        addCustom(this.state.value)
                        : this.setState({buttonText: "Select Color"})
                         : console.log("not brow pomade") };
                      // {product.meta.stock.availability === "out-stock" ? this.setState({buttonText: "Sold Out"}) : this.setState({buttonText: "Thank you"}) };
                      // {this.state.value === "0"}
                      this.setState({quickCheck: true});
                      e.preventDefault();
                    }}>
                  {this.state.buttonText}
                  </button>
               :
               <button
                    type="submit"
                    className="submit"
                    onClick={e => {
                      addToCart(product.id);
                      console.log(this.props.product.quantity);
                      console.log(product.meta.stock.availability);
                      console.log(this.state);
                      this.setState({quickCheck: true});
                      e.preventDefault();
                      // {product.meta.stock.availability === "out-stock"  && product.meta.stock.level === 1 ? this.setState({buttonText: "Sold Out"}) : this.setState({buttonText: "Thank you"}) };
                    }}>
                    {this.state.buttonText}
                  </button>
               }

              {this.state.quickCheck === true ? <Link className="btn submit" to="/checkout"> Checkout Now ?
                    </Link> : ""} 
                     
                 
                </form>
              </div>
            </div>
            <div className="product-info">
              <div className="product-details">
                <div className="header">
                  <h3>Product details</h3>
                </div>
                <div className="details-body">
                  <div className="row">
                    <div className="label">Care Instructions</div>
                    <div className="value">
                    <p>Please touch up every 2-3 weeks.
                    .Please Do not wet lashes for 24 hours
                    .Do not use waterproof mascara, cream or oil based eye products.
                     Use only water based makeup and remover.
                    .Do not tint, perm or use eyelash curler
                    .Be careful avoid rubbing eyes and pulling extensions.
                    .Always remove eyelash extensions before laying down for bed.
                    .Please make sure the area around your eyes are cleaned before applying eyelash extensions again.
                    .Always schedule touch ups every 2-3 weeks. </p>
                    </div>
                  </div>
              
                  <div className="row">
                    <div className="label">SKU</div>
                    <div className="value sku">{product.sku}</div>
                  </div>
                </div>
              </div>
              <div className="product-details">
                <div className="header">
                  <h3>Dimensions (cm)</h3>
                </div>
                <div className="details-body">
                  <div className="row">
                    <div className="label">Free</div>
                    <div className="value">All lash purchases come with
                    free disposable lash wands</div>
                  </div>
                  <div className="row">
                    <div className="label">Premium Packaging</div>
                    <div className="value">Our <strong>EXCLUSIVE</strong>  Signature Lash cases
                    come with every purchase of lashes. Courtesy of Shanise.<br/><strong>.Envy</strong> and <strong>.Savage</strong> come with Premium Round Cases.</div>
                  </div>
                </div>
              </div>
              <div className="product-details">
                <div className="header">
                  <h3>Delivery & returns</h3>
                </div>
                <div className="details-body">
                  <div className="row">
                    <div className="label">Dispatch</div>
                    <div className="value">Within 2 weeks</div>
                  </div>
                  <div className="row">
                    <div className="label">Delivery</div>
                    <div className="value">$6.70</div>
                  </div>
                </div>
                 <div> 
                    <p className="value">The low flat-rate shipping cost of $6.70 will be added to your cart. Go ahead, add as many items as you would like.
                    Your items will still arrive fashionably on time.  </p> 
                    </div>
                <div className="footer">
                  <p>
                    Read the <a href="/">delivery and returns policy</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

export default connect(mapStateToProps)(SingleProduct);



// WEBPACK FOOTER //
// ./src/components/Products/SingleProduct.js